import clsx from 'clsx';
import React from 'react';
import { sanitizers } from '@/utils/formValidation/sanitizers';
import { formatCurrencyValue } from '@/utils/poolCreateUtils';

type CurrencyFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  className?: string;
};

export const CurrencyField: React.FC<CurrencyFieldProps> = ({
  value,
  onChange,
  placeholder = '0.00',
  error = false,
  disabled = false,
  className = '',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizers.currency(e.target.value);
    onChange(sanitized);
  };

  // Format value with commas for display (no $ prefix since it's shown separately)
  const displayValue = formatCurrencyValue(value);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent +, -, e, E keys (scientific notation and signs)
    if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
    // Allow all other keys - sanitizer will clean them up
  };

  return (
    <div
      className={clsx(
        'w-full px-3 py-2.5 bg-[#F4F4F4] rounded-[10px] flex items-center gap-2.5',
        error && 'outline outline-1 outline-[#CC4747] -outline-offset-1',
        className
      )}
    >
      <div className="text-black text-sm font-medium">$</div>
      <input
        type="text"
        inputMode="numeric"
        value={displayValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className={clsx(
          'flex-1 min-w-0 bg-transparent border-none outline-none text-sm font-medium',
          value ? 'text-black' : 'text-[#B2B2B2] placeholder:text-[#B2B2B2]'
        )}
      />
    </div>
  );
};
